<script lang="ts" setup>
import { computed } from "vue";

import TooltipButton from "@/components/buttons/TooltipButton.vue";
import { useBrokerUpdate } from "@/composables";
import { useTripStore } from "@/store/trip.store";
import { isRouteTravelOrderInProgress } from "@/utils/routes";

import type { CheckCallWithUpdate } from "@/api/trips/dto/check-call";
import type { TravelOrderWithTruck } from "@/api/trips/dto/trip.dto";
import type { DisableRule } from "@/types/validation";

const tripStore = useTripStore();
const { createBrokerUpdateDisableRules } = useBrokerUpdate();

const props = defineProps<{
  checkCall: CheckCallWithUpdate;
  travelOrder: TravelOrderWithTruck | undefined;
}>();

const emits = defineEmits<{
  (e: "click"): void;
}>();

const route = computed(() => {
  return tripStore.tripOverview?.routes.find((item) => item.id === props.checkCall.routeId);
});

const disableRules = computed<DisableRule[]>(() => {
  return createBrokerUpdateDisableRules({
    sendUpdates: props.travelOrder?.order.customer.sendUpdates,
    routeStatus: route.value?.status,
    redispatch: route.value?.redispatch,
    isTechnicalPartial: route.value?.technicalPartial,
    isTravelOrderInProgress: isRouteTravelOrderInProgress(route.value, props.travelOrder?.id),
    isCheckCallDismissed: Boolean(props.checkCall.deletedBy),
  });
});
</script>

<template>
  <tooltip-button :rules="disableRules">
    <template #default="{ disabled }">
      <v-btn :disabled="disabled" class="text-uppercase" color="primary" variant="flat" @click="emits('click')">
        Create update
      </v-btn>
    </template>
  </tooltip-button>
</template>
